"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateManufacturerMasterSchema = exports.createManufacturerMasterSchema = exports.manufacturerMasterShape = void 0;
const zod_1 = require("zod");
exports.manufacturerMasterShape = {
    manufacturerCode: zod_1.z.string().min(1).max(30).optional(),
    name: zod_1.z.string().min(1).max(255),
    licenseNumber: zod_1.z.string().max(50).optional(),
    licenseExpiryDate: zod_1.z.coerce.date().optional(),
    gstin: zod_1.z.string().max(20).optional(),
    address: zod_1.z.string().optional(),
    contactEmail: zod_1.z.string().email().max(255).optional(),
    contactPhone: zod_1.z.string().max(20).optional(),
};
exports.createManufacturerMasterSchema = zod_1.z.object(exports.manufacturerMasterShape);
exports.updateManufacturerMasterSchema = exports.createManufacturerMasterSchema.partial();
//# sourceMappingURL=manufacturer-master.schema.js.map